import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
window.__appStore = store
import ElementUI from 'element-ui'
import * as filters from './utils/filter'

import '@/assets/styles/reset.css'
import '@/assets/styles/theme.css'
import '@/assets/font-awesome/scss/font-awesome.scss'
import '@/assets/styles/common.sass'
// import { setCookie } from '@/utils/tools.js'

Vue.config.productionTip = false

Vue.use(ElementUI)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.mixin({
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    correctImageUrl: (url) => {
      if (!url) return ''
      if (/^https?:\/\//.test(url)) return url
      return 'http://overseas-1252412068.costj.myqcloud.com' + url
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js